import HtmlText from 'common/typography/HtmlText';
import { DOMNode, domToReact, HTMLReactParserOptions } from 'html-react-parser';
import { extractNamespace, I18nProps, withLazyNamespaces } from 'i18n';

interface TranslatorProps extends I18nProps {
  id: string;
  defaultMessage: string;
}

export const htmlParserOptions: HTMLReactParserOptions = {
  replace: (domNode, index) => {
    const el = domNode as unknown as Element;
    if (el?.tagName === 'p' && index === 0) {
      return (
        <HtmlText as="span" variant="body.smallDemibold">
          {domToReact(el.children as unknown as DOMNode[])}
        </HtmlText>
      );
    }
  },
};

export const Translator = ({ id, defaultMessage, tHtml }: TranslatorProps) => (
  <>{tHtml(id, defaultMessage, undefined, htmlParserOptions)}</>
);

const ErrorTranslator = (id: string, defaultMessage: string) => {
  const namespace = extractNamespace(id);
  const Component = withLazyNamespaces(Translator, namespace);

  return function TranslatorError() {
    return <Component id={id} defaultMessage={defaultMessage} />;
  };
};

export default ErrorTranslator;
